<script>
export default {
  name: "PdfEdit"
}
</script>

<template>
<div></div>
</template>

<style scoped>

</style>
